import React from 'react';
import { ThemeProvider } from 'styled-components';
import { v2Theme, cssVariables } from './tokens';
import { V2GlobalStyles } from './V2GlobalStyles';

interface V2ThemeProviderProps {
  children: React.ReactNode;
}

/**
 * Wraps the v2 subtree with:
 * - A scoped root div that injects CSS variables
 * - styled-components ThemeProvider with v2 tokens
 * - Global styles (fonts, resets scoped to .v2-root)
 */
export const V2ThemeProvider: React.FC<V2ThemeProviderProps> = ({
  children
}) => {
  return (
    <ThemeProvider theme={v2Theme}>
      <V2GlobalStyles />
      <div
        className="v2-root"
        style={{ height: '100%', width: '100%', flex: 1, minWidth: 0 }}
      >
        {children}
      </div>
    </ThemeProvider>
  );
};
